export const FETCH_ORG_FLEXI_PARTNER_DETAILS = 'FETCH_ORG_FLEXI_PARTNER_DETAILS';
export const SYNC_ORG_FLEXI_PARTNER_DETAILS = 'SYNC_ORG_FLEXI_PARTNER_DETAILS';